export const closingCardComponent = {
	totalExpense: "Total de despesas lançadas",
};
